import React, { useState, useEffect, useContext } from 'react'
import { connect } from 'react-redux'

import { getTrainerIndex, fetchTrainerIndex } from '../../../store/admin'

import { capitalize, range } from '../../../shared/utilities/helpers'
import DialogBox from '../../../shared/ui/DialogBox'
import Button from '../../../shared/ui/Button'

import { withStyles } from '@material-ui/core/styles'
import { Box, Typography, Avatar } from '@material-ui/core'
import VisibilityIcon from '@material-ui/icons/Visibility'
import Link from '../../../shared/ui/Link'

const styles = theme => ({
  root: {
  },
  avatarButton: {
    width:120, 
    height:120, 
    position:'absolute', 
    bottom: 0, 
    cursor:'pointer', 
    background:'transparent'
  },
  avatarBox: {
    width:120, 
    height:30, 
    position:'absolute', 
    bottom: 0, 
    cursor:'pointer', 
    background:'#00000080'
  }
})

const PreferredTrainerSelectionForm = ({ theme, classes, open=true, data, initialData, lastFetched, isFetching, fetchTrainers, selectedTrainers, onAddTrainer, onRemoveTrainer, onClose }) => {
  const [formData, setFormData] = useState({})
  
  const defaultParticipantCount = range(10, 21) || []  

  useEffect(() => {
    // fetchTrainers()
  },[])
  
  const handleFormDataChange = name => (event, newValue) => {
    let eventValue = event.target.value
    let valueNew = newValue ? (newValue.props ? newValue.props.value : newValue) : newValue

    setFormData({
      ...formData,
      [name]: valueNew ? valueNew : eventValue
      }
    )
  }
  
  const isTrainerSelected = (trainer) => {
    return Boolean(selectedTrainers.find(t => t.uid == trainer.uid))
  }

  let actionButtons = [
    <Button fullWidth variant='contained' onClick={onClose} color="primary">
      Done
    </Button>
  ]
  
  return (
    <DialogBox show={open} onClose={onClose} title={'Select Trainer'} actionButtons={actionButtons}>
      <Box display='flex' flexDirection='row' flexWrap="wrap" mt={1} mb={1}>
          { initialData.trainers.map(trainer =>
            <Box 
              width='30%' 
              display='flex' m={1} 
              flexDirection='column' 
              justifyContent='center' 
              alignItems='center' 
              style={{position:'relative'}}
              >
                <Link 
                  style={{position:'relative', marginBottom: '4px'}} 
                  to={'/trainer/' + trainer.uid} 
                  target='_blank'
                  >
                    <Avatar 
                      alt={trainer.first_name + ' '+ trainer.last_name} 
                      src={trainer.profile_picture_url} 
                      style={{width:120, height:120}} 
                      />
                    <Avatar className={classes.avatarButton}>
                      <Box 
                        display='flex' 
                        justifyContent='center' 
                        alignItems='center' 
                        className={classes.avatarBox}
                        >
                        <Typography variant='body2' style={{color:'white'}}>
                          View
                        </Typography>
                      </Box>
                    </Avatar>
                </Link>
                <Typography variant='body1'>
                  {trainer.first_name + ' '+ trainer.last_name}
                </Typography>
                <Button 
                  disabled={isTrainerSelected(trainer)}
                  color={isTrainerSelected(trainer) ? 'disabled' : 'primary'} 
                  onClick={() => {
                    if (isTrainerSelected(trainer))
                      onRemoveTrainer(trainer)
                    else
                      onAddTrainer(trainer)
                  }}
                  >
                  { isTrainerSelected(trainer) ? 'Selected' : 'Add' }
                </Button>
            </Box>
          )}
        </Box>
    </DialogBox>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    ...getTrainerIndex(state, "", null)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    fetchTrainers: (params) => {
        dispatch(fetchTrainerIndex("", params, true))
    }
  }
}

export default withStyles(styles, { withTheme: true })(
  connect(
    mapStateToProps,
    mapDispatchToProps
   )(PreferredTrainerSelectionForm)
)
